import React from "react";

const AdventureSection = () => {
  return (
    <div
      className="section-full py-3 site-bg-white twm-step-towards-section-wrap wow fadeInDown"
      data-wow-offset="100"
      data-wow-delay="0.2"
    >
      <div className="container">

        {/* Title */}
        <div className="section-head center">
          <div className="twm-sm-title left">Our Services</div>
          <h2 className="twm-large-title site-text-dark">
            Making Every Ride Safe, Easy & Comfortable
          </h2>
        </div>

        <div className="section-content">
          <div className="row twm-step-towards-section">

            {/* Card 1 */}
            <div className="col-lg-4 col-md-6 m-b30">
              <div className="twm-icon-style-left2 large-set">
                <div className="twm-media">
                  <img src="images/icons/label.png" alt="Affordable Pricing" />
                </div>
                <div className="twm-content">
                  <h3 className="twm-title">Affordable Pricing</h3>
                  <p>
                    Enjoy budget-friendly cab rides with clear pricing and no hidden charges for every trip.
                  </p>
                </div>
              </div>
            </div>

            {/* Card 2 */}
            <div className="col-lg-4 col-md-6 m-b30">
              <div className="twm-icon-style-left2 large-set">
                <div className="twm-media">
                  <img src="images/icons/customer-support.png" alt="24/7 Support" />
                </div>
                <div className="twm-content">
                  <h3 className="twm-title">24/7 Support</h3>
                  <p>
                    Our support team is available anytime to assist you and ensure a smooth travel experience always.
                  </p>
                </div>
              </div>
            </div>

            {/* Card 3 */}
            <div className="col-lg-4 col-md-6 m-b30">
              <div className="twm-icon-style-left2 large-set">
                <div className="twm-media">
                  <img src="images/icons/parking-area.png" alt="Pickup & Drop" />
                </div>
                <div className="twm-content">
                  <h3 className="twm-title">Pickup & Drop</h3>
                  <p>
                    Get quick doorstep pickup and drop services with comfort, safety, and reliability every time.
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
};

export default AdventureSection;